var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"display":"inline-block"}},[_c('div',{on:{"click":function($event){_vm.visible = true}}},[_vm._t("default")],2),_c('a-modal',{attrs:{"title":"选择项目备案","visible":_vm.visible,"footer":null,"width":"900px"},on:{"cancel":_vm.cancel}},[_c('a-input-search',{attrs:{"placeholder":"请输入项目名称搜索","enter-button":""},on:{"search":_vm.onSearch}}),_c('Padding'),_c('a-table',{staticStyle:{"table-layout":"fixed"},attrs:{"bordered":"","data-source":_vm.list,"loading":_vm.loading,"pagination":{
        total: _vm.total,
        current: _vm.current,
        pageSize: _vm.pageSize,
        showTotal: (total) => `共 ${total} 条记录`,
      },"rowClassName":() => 'clickable',"customRow":(record) => {
          return {
            on: {
              click: () => {
                _vm.onTableRowClick(record);
              },
            },
          };
        },"scroll":{ x: 500 }},on:{"change":_vm.onChange}},[_c('a-table-column',{attrs:{"title":"序号","width":60,"align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(text, record, index){return [_vm._v(" "+_vm._s((_vm.current - 1) * _vm.pageSize + index + 1)+" ")]}}])}),_c('a-table-column',{attrs:{"title":"备案编号","data-index":"filingNum","width":160}}),_c('a-table-column',{attrs:{"title":"项目名称","data-index":"projectName","minWidth":"340"}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }